export default __webpack_public_path__ + "static/media/gambar-15.9ff0e5a4.png";